import { CoreFormFieldPhone } from '../fields/CoreFormFieldPhone';
import type { ContextFormFieldBaseProps } from './ContextFormFieldBaseProps';
import type { FormFieldControllerRulesProps } from './FormFieldController';
import { FormFieldController } from './FormFieldController';

export const ContextFormFieldPhone = ({
  fieldPath,
  rules,
  disabled,
  label,
  inline,
  placeholder,
  helperText,
}: ContextFormFieldBaseProps) => {
  return (
    <FormFieldController
      name={fieldPath}
      rules={rules as FormFieldControllerRulesProps}
    >
      {({ field, fieldState }) => (
        <CoreFormFieldPhone
          label={rules?.required ? `${label} *` : label}
          error={fieldState.error?.message?.toString()}
          inputProps={{
            id: fieldPath,
            name: field.name,
          }}
          value={field.value || ''}
          onChange={field.onChange}
          disabled={disabled}
          inline={inline}
          helperText={helperText}
          placeholder={placeholder}
        />
      )}
    </FormFieldController>
  );
};
